<template>
  <b-dropdown
    right
    no-caret
    class="button-export"
    :toggle-class="`btn-export ${size}`"
    :disabled="disabled"
    :variant="disabled ? 'secondary' : 'primary'"
  >
    <template #button-content>
      <loading :show="loading">
        <i class="fa fa-download" />
        <div class="ml-5 d-none d-lg-flex align-items-center">
          <span>Exportar</span>
          <div class="divider" />
          <i class="fa fa-angle-down" />
        </div>
      </loading>
    </template>

    <b-dropdown-item
      v-for="option in options"
      :key="option.value"
      @click="$emit('input', option.value)"
      class="fs-14"
      style="color: #3B3B4AE5;"
    >
      <i class="mr-3 fa" :class="option.icon" />
      Arquivo compacto em {{ option.text }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    loading: Boolean,
    value: String,
    size: {
      type: String,
      default: "md"
    }
  },
  data() {
    return {
      options: [
        { value: "csv", text: "CSV", icon: "fa-file-csv" },
        { value: "excel", text: "Excel", icon: "fa-table" }
      ]
    };
  }
};
</script>

<style lang="scss">
.button-export {
  .btn-export {
    min-width: unset;

    &.sm {
      min-height: 32px;
      min-width: 32px;
      padding: 0 8px !important;

      @media screen and (max-width: 991px) {
        padding: 0;
        width: 32px;
        height: 32px;
      }
    }

    &.md {
      min-height: 40px;
      min-width: 40px;
      padding: 0 16px !important;

      @media screen and (max-width: 991px) {
        padding: 0;
        width: 40px;
        height: 40px;
      }
    }

    .loading {
      span {
        display: flex;
        align-items: center;
      }

      .divider {
        border-left: 1px solid white;
        margin: 0 16px;
        opacity: 0.24;
        height: 24px;
      }
    }
  }
}
</style>
